import React, { useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "./Zoe_miller_slider.css";
import Explore_btn from "../../common-components/common-buttons/explore-button/Explore_btn";
import "swiper/css";
import "swiper/css/effect-cards";
import "swiper/css/navigation";
import { EffectCards } from "swiper/modules";
import { Navigation } from "swiper/modules";
import { useDispatch, useSelector } from "react-redux";

import { postWishlist } from "../../../features/wishlist/wishlistSlice";
import { useNavigate } from "react-router-dom";
import { encodeId } from "../../../utils/common";
import InnerImageZoom from 'react-inner-image-zoom';
const Zoe_miller_slider = ({ products }) => {
  const zoemillerslider = [
    {
      image: "/assets/images/home/zoe-miller/g1.png",
      title: "Zoe Miller1",
      description:
        "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution",
    },
    {
      image: "/assets/images/home/zoe-miller/g1.png",
      title: "Zoe Miller2",
      description:
        "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution",
    },
    {
      image: "/assets/images/home/zoe-miller/g1.png",
      title: "Zoe Miller3",
      description:
        "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution",
    },
    {
      image: "/assets/images/home/zoe-miller/g1.png",
      title: "Zoe Miller4",
      description:
        "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution",
    },
    {
      image: "/assets/images/home/zoe-miller/g1.png",
      title: "Zoe Miller5",
      description:
        "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution",
    },
  ];
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [activeIndex, setActiveIndex] = useState(0);
  const is_signin = useSelector((state) => state.auth.is_signin);
  const [productId, setProductId] = useState(0);

  const addToWish = async () => {
    if (!is_signin) {
      navigate("/login");
      return;
    } else {
      const res = await dispatch(
        postWishlist({ product_id: products?.data?.[activeIndex]?.id })
      );

      if (res.meta?.requestStatus === "fulfilled") {
        setTimeout(() => {
          navigate("/wishlist");
        }, 500);
      } else if (res.meta?.requestStatus === "rejected") {
      }
    }
  };

  return (
    <>
      <section className="Zoe_miller_slider">
        <div className="container">
          <div className="row">
            <div className="col-xl-5 col-lg-5 col-md-7 col-12 mx-auto">
              <div className="slidersec">
                <div className="deskview">
                  <Swiper
                    effect={"cards"}
                    grabCursor={true}
                    modules={[EffectCards, Navigation]}
                    className="mySwiper"
                    navigation={true}
                    onSlideChange={(swiper) =>
                      setActiveIndex(swiper.activeIndex)
                    }
                  >
                    {products?.data?.map((data, index) => (
                      <SwiperSlide
                        key={index}
                        onClick={() => {
                          setProductId(data?.id);
                        }}
                      >
                        {/* <div className="slide_div">
                          <img
                            className="slideimg"
                            src={process.env.REACT_APP_IMAGE_URL + data.image}
                            alt={`Slide ${index + 1}`}
                          />
                        </div> */}

                        <div className="slide_div">
                          <img
                            {...{
                              smallImage: {
                                alt: `Slide ${index + 1}`,
                                isFluidWidth: true,
                                className: "slideimg",
                                src:
                                  process.env.REACT_APP_IMAGE_URL + data.image,
                              },

                              largeImage: {
                                src:
                                  process.env.REACT_APP_IMAGE_URL + data.image,
                                width: 1200,
                                height: 1200,
                              },

                              // 👉 magnified image appears over the table/section
                              enlargedImagePosition: "over",

                              // 👉 ensure magnified image stays on top
                              enlargedImageContainerStyle: {
                                zIndex: 99999999,
                                background: "white",
                                border: "1px solid #ddd",
                                boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
                                borderRadius: "12px",
                              },

                              // Optional
                              // enlargedImageContainerDimensions: {
                              //   width: "200%",
                              //   height: "200%",
                              // },
                            }}
                          />
                        </div>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>

                <div className="mobview">
                  <Swiper
                    // effect={'cards'}
                    grabCursor={true}
                    modules={[EffectCards, Navigation]}
                    className="mySwiper"
                    navigation={true}
                    onSlideChange={(swiper) =>
                      setActiveIndex(swiper.activeIndex)
                    }
                  >
                    {products?.data?.map((data, index) => (
                      <SwiperSlide key={index}>
                        <div className="slide_div">
                          <img
                            className="slideimg"
                            src={process.env.REACT_APP_IMAGE_URL + data.image}
                            alt={`Slide ${index + 1}`}
                          />
                        </div>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
              </div>
            </div>
            <div className="col-lg-4 mt-3">
              <div className="cont-sec">
                <h1 className="zoemiltitle">
                  {products?.data?.[activeIndex]?.Brand?.name}
                </h1>
                <p className="subcontt">
                  {products?.data?.[activeIndex].description}
                </p>

                <div className="btgroyp">
                  <Explore_btn
                    name={"Add To Wishlist"}
                    onClick={() => {
                      addToWish();
                    }}
                  />
                  <Explore_btn
                    name={"Buy Now"}
                    link={`/product-descrption/${encodeId(
                      products?.data?.[activeIndex]?.id
                    )}`}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Zoe_miller_slider;
